// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"72a08b7c","604":"7d73e17c","611":"d9fcb920","672":"ff704a81","677":"80b494c0","688":"62b52280","901":"a8bf7532"}[chunkId] + ".chunk.js";
};